const { gql } = require('graphql-tag');

module.exports = gql`
  mutation createPayment($draft: MyPaymentDraft!) {
          payment: createMyPayment(draft: $draft) { id }
      }
`;
